import { observeElementInView } from "../vendor/inview-observer";
// eslint-disable-next-line import/no-unresolved -- swiper/bundle is a valid package export; resolver doesn't follow package.json "exports"
import Swiper from "swiper/bundle";

const initCaseStudiesGrid = (section) => {
	if (section.dataset.initialized === "true") {
		return;
	}

	const root = section.querySelector(".case-studies-grid__swiper");
	const prev = section.querySelector(".case-studies-grid__nav--prev");
	const next = section.querySelector(".case-studies-grid__nav--next");

	if (!root) {
		return;
	}

	const slides = root.querySelectorAll(".swiper-slide");

	if (!slides.length) {
		return;
	}

	new Swiper(root, {
		slidesPerView: 1,
		spaceBetween: 24,
		speed: 600,
		watchOverflow: true,
		grabCursor: slides.length > 1,
		navigation:
			prev && next && slides.length > 1
				? {
						prevEl: prev,
						nextEl: next,
					}
				: undefined,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 32,
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 40,
			},
			1600: {
				slidesPerView: 3,
				spaceBetween: 80,
			},
		},
	});

	section.dataset.initialized = "true";
};

const boot = () => {
	document.querySelectorAll(".case-studies-grid.is-slider").forEach((section) => {
		observeElementInView(section, () => initCaseStudiesGrid(section));
	});
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
